export default "__VITE_ASSET__B3Ico5Jm__"